// Plyr non è più importato staticamente: erano ~112 KB di JS su OGNI pagina,
// mentre il player serve solo dove CKEditor ha lasciato un <oembed url="...">
// — in pratica gli articoli del blog e le pagine di testo. Home, liste e schede
// non ne hanno mai nemmeno uno.
//
// Il CSS resta dov'è (resources/sass/components/plyr_custom.scss, dentro
// app.scss): è poca roba ed è già in un foglio unico.

let plyrPromise = null;

window.loadPlyr = function () {
    if (!plyrPromise) {
        plyrPromise = import('plyr').then((module) => {
            const Plyr = module.default ?? module;
            window.Plyr = Plyr;
            return Plyr;
        });
    }
    return plyrPromise;
};
